// Per-inbox visitor state on the host page. Storage can be unavailable (private mode, blocked
// site data), in which case the chat still works and simply starts fresh on the next page load.
const read = (store, key) => {
  try {
    return JSON.parse(store.getItem(key) || '{}');
  } catch {
    return {};
  }
};

const write = (store, key, value) => {
  try {
    store.setItem(key, JSON.stringify(value));
  } catch {
    // ignored: see above
  }
};

export const createStorage = websiteToken => {
  const key = `arkemis-chat:${websiteToken}`;
  return {
    get: () => read(window.localStorage, key),
    set: patch =>
      write(window.localStorage, key, {
        ...read(window.localStorage, key),
        ...patch,
      }),
    session: () => read(window.sessionStorage, key),
    setSession: patch =>
      write(window.sessionStorage, key, {
        ...read(window.sessionStorage, key),
        ...patch,
      }),
  };
};
